export const ActivePurсhasedServicesByService = {
  en: {
    'Active Purchased Services By Service':
      'Active Purchased Services By Service',
  },
  uk: {
    'Active Purchased Services By Service':
      'Кількість активних куплених сервісів',
  },
};
